export default __webpack_public_path__ + "static/media/editIcon.e01b7b29.svg";